import { render, staticRenderFns } from "./HomeNew.vue?vue&type=template&id=299a5b77&scoped=true"
import script from "./HomeNew.vue?vue&type=script&lang=js"
export * from "./HomeNew.vue?vue&type=script&lang=js"
import style0 from "./HomeNew.vue?vue&type=style&index=0&id=299a5b77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299a5b77",
  null
  
)

export default component.exports